<template>
  <div>
    <v-tabs class="mb-4" color="#eee" :slider-color="$vuetify.theme.primary">
      <v-tab :to="{ name: 'ticket3-agent-performance-detail' }">Agent Performance</v-tab>
      <v-tab :to="{ name: 'ticket3-agent-performance-summary' }">Agent Performance Summary</v-tab>
      <v-tab v-if="isHotstar" :to="{ name: 'ticket3-agent-work-time' }">Agent Work Time</v-tab>
    </v-tabs>

    <v-container fluid>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page'

export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isHotstar() {
      return PAGE.HOTSTAR.includes(this.selectedBot.pageid)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/AgentPerformance.vue